import type { IconGlyph } from '@sunwebgroup/uds-ui/icon'

export interface CheckoutServiceBanner {
  title?: string
  text?: string
  type: string
}

export interface CheckoutServiceParticipant {
  id: string
  roomId?: string
  name: string
  selectedValue: string | null
  selectedId?: string | null
  availableOptions: string[]
  birthdate: string | null
  ageCategory: CheckoutParticipantAgeCategory
}

export interface CheckoutServiceFeature {
  code: string
  icon: IconGlyph | null
  description: string
  extraContent?: {
    linkText: string
  }
}

export interface CheckoutServiceOption {
  label: string
  badge?: string
  value: string
  price: number
  rawPrice?: number
  percentage?: string
  percentageText?: string
  priceAssignments?: CheckoutServiceOptionPriceAssignationParticipant[]
  features?: string[]
  modalInformation?: {
    title: string
    body: string
  }
}

export interface CheckoutServiceOptionPriceAssignationParticipant {
  price: number
  participantIds: string[]
}

export const AgeCategoryValues = {
  ADULT: 'Adult',
  CHILD: 'Child',
  BABY: 'Baby'
} as const
export type CheckoutParticipantAgeCategory = typeof AgeCategoryValues[keyof typeof AgeCategoryValues]

export interface CheckoutServiceRoom {
  id: string
  name: string
  participantIds: string[]
  selectedValue?: string
  availableOptions?: string[]
}

export const bannerColorMap = {
  info: 'informative',
  warning: 'warning',
  error: 'danger',
  success: 'success',
}
